import { IntlShape } from 'react-intl';
import { TicketRateLine } from '../generated/graphql';
import parseDateTime from './parseDateTime';

const createTicketText = (intl: IntlShape, startDateTime: string, rateLines: Array<Pick<TicketRateLine, 'amount'>>) =>
    intl.formatMessage(
        {
            defaultMessage:
                '{ticketsAmount, number} {ticketsAmount, plural, one {ticket} other {tickets}}, {date} om {time}',
        },
        {
            date: intl.formatDate(parseDateTime(startDateTime), { format: 'DAYMONTHYEAR' }),
            time: intl.formatTime(parseDateTime(startDateTime)),
            ticketsAmount: rateLines.reduce((total, line) => total + Number(line.amount ?? 0), 0),
        }
    );

export default createTicketText;
